import { Spinner } from "@/shadcn/components/ui/spinner"

export function BootstrapScreen() {
  return (
    <main className="flex min-h-screen items-center justify-center px-6">
      <Spinner size={50} thickness={2} color="primary" />
    </main>
  )
}

export default BootstrapScreen
